<template>
  <div class="lissajous-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>x = A·sin(ω₁t + φ) | y = B·sin(ω₂t)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Curve -->
          <path :d="curvePath" fill="none" stroke="#00d2ff" stroke-width="2" />
          
          <!-- Oscilloscopes Markers -->
          <line x1="50" y1="120" x2="350" y2="120" stroke="rgba(255,255,255,0.1)" />
          <line x1="200" y1="20" x2="200" y2="220" stroke="rgba(255,255,255,0.1)" />

          <!-- Scanning Dots -->
          <circle :cx="currentPos.x" :cy="currentPos.y" r="5" fill="#ff4757">
             <animate attributeName="opacity" values="1;0.5;1" dur="0.2s" repeatCount="indefinite" />
          </circle>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>频率比 f_x : f_y = {{ ratioX }} : {{ ratioY }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>X轴频率 f_x</label>
             <el-slider v-model="ratioX" :min="1" :max="5" size="mini"></el-slider>
          </div>
          <div class="row items-center">
             <label>Y轴频率 f_y</label>
             <el-slider v-model="ratioY" :min="1" :max="5" size="mini"></el-slider>
          </div>
          <div class="row items-center">
             <label>相位差 φ</label>
             <el-slider v-model="phaseDegree" :min="0" :max="360" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>当两个相互垂直的简谐振动叠加时，质点的运动轨迹即为**利萨茹图形**。图形的形状取决于两个振动的频率比和相位差。在示波器实验中，这种图形常被用来测量未知信号的频率。当频率成简单整数比时，图形会闭合形成稳定的精美图案。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LissajousCurvesViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      ratioX: 3,
      ratioY: 2,
      phaseDegree: 90,
      time: 0,
      timer: null
    }
  },
  computed: {
    phase() { return (this.phaseDegree * Math.PI) / 180; },
    curvePath() {
       let pts = [];
       for (let t = 0; t <= Math.PI * 2 + 0.01; t += 0.05) {
          let x = 200 + 120 * Math.sin(this.ratioX * t + this.phase);
          let y = 120 + 80 * Math.sin(this.ratioY * t);
          if (!isNaN(x) && !isNaN(y)) pts.push(`${x.toFixed(1)} ${y.toFixed(1)}`);
       }
       return pts.length > 0 ? "M " + pts.join(" L ") + " Z" : "";
    },
    currentPos() {
       return {
          x: 200 + 120 * Math.sin(this.ratioX * this.time + this.phase),
          y: 120 + 80 * Math.sin(this.ratioY * this.time)
       };
    }
  },
  methods: {
    update() {
       this.time += 0.02;
       this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { if (this.timer) cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.lissajous-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
.row { display: flex; align-items: center; gap: 15px; margin-bottom: 5px; label { width: 80px; font-size: 12px; color: #888; } .el-slider { flex: 1; } }
</style>
